export var serializeProbe = function (probe) {
    var _a;
    return {
        _type: 'if',
        probe: {
            _type: 'catalog',
            probeAmplifierId: ((_a = probe.probeAmplifier) === null || _a === void 0 ? void 0 : _a.id) || -1
        },
        scaleUgram: probe.scale.ugram
    };
};
export var serializeBuffers = function (buffers, legacy) { return ({
    _type: 'if',
    antibodyBufferMl: buffers.antibody.valueMl,
    antibodyWashBufferMl: !legacy ? buffers.antibodyWash.valueMl : 0,
    amplificationBufferMl: buffers.amplification.valueMl,
    goldAmpWashBufferMl: !legacy ? buffers.goldAmpWash.valueMl : 0
}); };
//# sourceMappingURL=KitSerialization.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/secondary-if/KitSerialization.js
// module id = 1150
// module chunks = 0